import React from 'react';

const SvgHk = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="HK_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="HK_svg__b" fill="#fff">
        <use xlinkHref="#HK_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#HK_svg__a" />
      <path fill="#F0371D" mask="url(#HK_svg__b)" d="M0 0h28v20H0z" />
      <path
        d="M16 9.587c-1.064-.666-1.333.545-1.333 0 0-1.104 1.194-2 2.666-2 1.473 0 2.667.896 2.667 2-1.265 0-1.392.667-2 .667-.747 0-.936 0-2-.667zm1.667-.254a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666zm-2.415 2.617c.305-1.218-.93-1.1-.412-1.268 1.05-.341 2.271.517 2.726 1.918.455 1.4-.027 2.813-1.078 3.154-.39-1.203-1.064-1.117-1.252-1.696-.23-.71-.29-.89.016-2.108zm.757 1.507a.333.333 0 1 0 .634-.206.333.333 0 0 0-.634.206zm-3.235-1.488c1.252-.086.758-1.225 1.079-.784.649.894.21 2.32-.982 3.186-1.192.865-2.684.843-3.333-.051 1.023-.744.734-1.357 1.226-1.715.604-.439.757-.55 2.01-.636zm-1.2 1.185a.333.333 0 1 0 .393.54.333.333 0 0 0-.392-.54zm.416-3.536c.469 1.164 1.399.343 1.079.783-.65.894-2.142.917-3.333.05-1.192-.865-1.631-2.29-.982-3.185 1.024.744 1.518.279 2.01.637.604.439.757.55 1.226 1.715zm-1.497-.775a.333.333 0 1 0-.392.54.333.333 0 0 0 .392-.54zm3.491-.697c-.963.806.106 1.436-.412 1.268-1.05-.342-1.533-1.754-1.078-3.154C12.949 4.859 14.17 4 15.22 4.34c-.39 1.204.204 1.53.016 2.109-.23.71-.29.89-1.252 1.696zm.274-1.664a.333.333 0 1 0-.634-.206.333.333 0 0 0 .634.206z"
        fill="#FFF"
        mask="url(#HK_svg__b)"
      />
    </g>
  </svg>
);

export default SvgHk;
